import VisibilityIcon from "@mui/icons-material/Visibility";
import {
	Box,
	IconButton,
	TableCell,
	TableRow,
	Tooltip,
	Typography,
	useTheme,
} from "@mui/material";
import { Link } from "react-router-dom";
import type { IB2B_list } from "../type/b2bType";
import { getStatusLabel } from "src/Utils/Combined";

interface IProps {
	b2bData: IB2B_list;
	paginationSkip: number;
	index: number;
}

const B2BTableRow = ({ b2bData, paginationSkip, index }: IProps) => {
	const theme = useTheme();
	return (
		<TableRow hover>
			<TableCell>
				<Typography
					variant='body1'
					color='text.primary'
					gutterBottom
					noWrap
				>
					{index + 1 + Number(paginationSkip)}
				</Typography>
			</TableCell>
			<TableCell>
				<Box sx={{ display: "flex" }}>
					<Typography
						variant='body1'
						color='text.primary'
						gutterBottom
						noWrap
					>
						{b2bData?.b2b_first_name} {b2bData?.b2b_last_name}
					</Typography>
				</Box>
			</TableCell>
			<TableCell>
				<Typography
					variant='body1'
					color='text.primary'
					gutterBottom
					noWrap
				>
					{b2bData?.b2b_designation}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography
					variant='body1'
					color='text.primary'
					gutterBottom
					noWrap
				>
					{b2bData?.b2b_organization}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography
					variant='body1'
					color='text.primary'
					gutterBottom
					noWrap
				>
					{b2bData?.b2b_type}
				</Typography>
			</TableCell>

			<TableCell>
				<Typography
					variant='body1'
					color='text.primary'
					gutterBottom
					noWrap
				>
					{b2bData?.b2b_phone}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography
					variant='body1'
					color='text.primary'
					gutterBottom
					noWrap
				>
					{b2bData?.b2b_email}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography
					variant='body1'
					color='text.primary'
					gutterBottom
					noWrap
				>
					{getStatusLabel(b2bData.b2b_status)}
				</Typography>
			</TableCell>

			<TableCell>
				<Link to={`/b2b/list/${b2bData?.b2b_id.toString()}`}>
					<Tooltip title='View' arrow>
						<IconButton
							sx={{
								"&:hover": {
									background: theme.colors.primary.lighter,
								},
								color: theme.palette.primary.main,
							}}
							color='inherit'
							size='small'
						>
							<VisibilityIcon fontSize='small' />
						</IconButton>
					</Tooltip>
				</Link>
			</TableCell>
		</TableRow>
	);
};

export default B2BTableRow;
